module.exports = __webpack_public_path__ + "img/card-logos.10f84cd4.jpg";